import { BaseService, Body, GET, POST, QueryMap, Signal } from 'ts-retrofit3';

import { AUTH_API } from '@/Module/Auth/Constant';
import type { IAuthLoginVerifyOtpCodeBody, IAuthSendOtpCodeQuery } from '@/Module/Auth/Model/ApiModel';
import type { IInoAuth } from '@/Module/Auth/Model/DataModel';
import type { InoResponse } from '@/Module/Core/Model/ApiModel';
import { InoHttpService } from '@/Module/Core/Service';

class InoAuthService extends BaseService {
  // Send OTP Code
  @GET(AUTH_API.SEND_OTP_CODE)
  async sendOtpCode(@QueryMap _query: IAuthSendOtpCodeQuery, @Signal _signal?: AbortSignal): Promise<InoResponse> {
    return <InoResponse>{};
  }

  // Confirm Verification Code
  @POST(AUTH_API.LOGIN_VERIFY_OTP_CODE)
  async loginVerifyOtpCode(
    @Body _body: IAuthLoginVerifyOtpCodeBody,
    @Signal _signal?: AbortSignal,
  ): Promise<InoResponse<IInoAuth>> {
    return <InoResponse>{};
  }
}

export default InoHttpService.build(InoAuthService);
